<template>
  <div class="t-filter-wrapper">
    <t-form-label>{{ label }}</t-form-label>
    <slot />
  </div>
</template>

<script>
import TFormLabel from '../TForm/TFormLabel.vue';

export default {
  name: 't-filter-wrapper',

  components: {
    TFormLabel,
  },

  props: {
    label: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>
